// extracted by mini-css-extract-plugin
export default {"btnpwd":"_24ea7fc2f0"};